import app from '../app';
import giftCardSelection from './product/gift-card-selection';
import preorder from './product/preorder';
import productInfodrawer from './product/product-infodrawer';

import productMedia from './product/product-media';
import productReviews from './product/product-reviews';
import productSelection from './product/product-selection';
import relatedProducts from './product/related-products';
import productSticky from './product/product-sticky';
import sizeCalculator from './product/size-calculator';

app.add({
  giftCardSelection,
  productMedia,
  productSelection,
  productInfodrawer,
  relatedProducts,
  preorder,
  productReviews,
  productSticky,
  sizeCalculator
});
app.mount();
